import { render, staticRenderFns } from "./FormDesignMobilePreview.vue?vue&type=template&id=4d6a68b6&scoped=true"
import script from "./FormDesignMobilePreview.vue?vue&type=script&lang=js"
export * from "./FormDesignMobilePreview.vue?vue&type=script&lang=js"
import style0 from "./FormDesignMobilePreview.vue?vue&type=style&index=0&id=4d6a68b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6a68b6",
  null
  
)

export default component.exports